import React, { Component } from 'react';
import SectionTitleOne from '../SectionTitleOne';

class BlogOneWordPress extends Component {
    constructor(props) {
        super(props);
        this.state = {
            posts: [],
            loading: true,
            error: null
        };
    }

    componentDidMount() {
        this.fetchBlogPosts();
    }

    fetchBlogPosts = async () => {
        try {
            // Fetch posts with embedded featured media
            const response = await fetch(
                'https://sleeptherapeutics.in/blog/wp-json/wp/v2/posts?per_page=3&_embed'
            );

            if (!response.ok) {
                throw new Error('Failed to fetch blog posts');
            }

            const data = await response.json();

            // Transform the data to match the existing format
            const transformedPosts = data.map(post => ({
                id: post.id,
                title: post.title.rendered,
                date: new Date(post.date).toLocaleDateString('en-US', {
                    day: '2-digit',
                    month: 'short',
                    year: 'numeric'
                }),
                link: post.link,
                imgUrl: this.getFeaturedImage(post)
            }));

            this.setState({
                posts: transformedPosts,
                loading: false
            });
        } catch (error) {
            console.error('Error fetching blog posts:', error);
            this.setState({
                error: error.message,
                loading: false
            });
        }
    };

    getFeaturedImage = (post) => {
        // Try to get featured image from embedded data
        if (post._embedded &&
            post._embedded['wp:featuredmedia'] &&
            post._embedded['wp:featuredmedia'][0] &&
            post._embedded['wp:featuredmedia'][0].source_url) {
            return post._embedded['wp:featuredmedia'][0].source_url;
        }
        // Fallback image
        return 'https://sleeptherapeutics.in/blog/wp-content/uploads/2023/08/Sleep-Therapeutics-_-August-Blog-01-1568x882.jpg';
    };

    // Decode HTML entities in title
    decodeHtml = (html) => {
        const txt = document.createElement('textarea');
        txt.innerHTML = html;
        return txt.value;
    };

    render() {
        const { posts, loading, error } = this.state;

        if (loading) {
            return (
                <section className="blog-wrapper blog-one section-padding pt-0">
                    <div className="container">
                        <SectionTitleOne BigTitle="Latest Blog" />
                        <div className="row">
                            <div className="col-12 text-center">
                                <p>Loading latest blogs...</p>
                            </div>
                        </div>
                    </div>
                </section>
            );
        }

        if (error) {
            return (
                <section className="blog-wrapper blog-one section-padding pt-0">
                    <div className="container">
                        <SectionTitleOne BigTitle="Latest Blog" />
                        <div className="row">
                            <div className="col-12 text-center">
                                <p>Unable to load blogs at this time.</p>
                            </div>
                        </div>
                    </div>
                </section>
            );
        }

        return (
            <section className="blog-wrapper blog-one section-padding pt-0">
                <div className="container">
                    <SectionTitleOne BigTitle="Latest Blog" />
                    <div className="row">
                        {posts.map((item) => (
                            <div className="col-md-6 col-lg-6 col-xl-4 col-sm-12" key={item.id}>
                                <div className="single-blog-card">
                                    <div className="featured-thumb">
                                        <img src={item.imgUrl} alt={this.decodeHtml(item.title)} />
                                    </div>
                                    <div className="card-content">
                                        <h3>
                                            <a href={item.link} target="_blank" rel="noopener noreferrer">
                                                {this.decodeHtml(item.title)}
                                            </a>
                                        </h3>
                                        <div className="card-meta">
                                            <div className="col-6">
                                                <span>{item.date}</span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </section>
        );
    }
}

export default BlogOneWordPress;
